module.exports = __webpack_public_path__ + "static/media/icon-delete-blue.4b467640.svg";